import React  from 'react';
import './App.css';
import './DashboardMain.css';
import { useNavigate } from "react-router-dom";
import DashboardLang from './DashboardLang.json';

import ToolbarPopupMenu from "./ToolbarPopupMenu.js"

class DashboardMainToolbar extends React.Component {

	constructor(props) {

		super(props);
				
		this.state = {
			innerWidth: 0,
			innerHeight: 0,
			showPopupMenuYN: false,
		}
		
		this.updateDimensions = this.updateDimensions.bind(this);
		this.handleSelectDashboard = this.handleSelectDashboard.bind(this);
		this.handleSelectLink = this.handleSelectLink.bind(this);
		this.handlePopupLink = this.handlePopupLink.bind(this);
		this.closePopupMenu = this.closePopupMenu.bind(this);
		this.renderLink = this.renderLink.bind(this);
		this.renderRight = this.renderRight.bind(this);
	}
	
	componentDidMount() {
		this.updateDimensions();
		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount() {
		document.removeEventListener('resize', this.updateDimensions, true);
	};
	
	updateDimensions = () => {
		this.setState({ innerWidth: window.innerWidth, innerHeight: window.innerHeight });
	};
	
	handleSelectDashboard() {
		const navigate = this.props.navigate;
  		navigate("/selectdashboard");
	}
	
	handleSelectLink(tab) {
		this.props.setTab(tab);
	}
	
	handlePopupLink() {
		this.setState({showPopupMenuYN: true});
	}

	closePopupMenu() {
		this.setState({showPopupMenuYN: false});
	}
	
	renderLink(linkTitle, linkValue, key, selectedYN) {

		var classNameString = "DashboardMainToolbarLink";
					
		if (selectedYN) {
			classNameString = "DashboardMainToolbarSelectedLink";
		}
		
		return (
			<div 
				key={key}
				className={classNameString}
				onClick={() => this.handleSelectLink(linkValue)}
			>
				{linkTitle}
			</div>
		);
	}
	
	renderPopupLink(linkTitle, variableNameArray) {

		var classNameString = "DashboardMainToolbarSelectedLink";
		
		return (
			<div 
				key="popup-link"
				className={classNameString}
			>
				<div 
					className={classNameString}
					onClick={() => this.handlePopupLink()}
				>
					{linkTitle}
				</div>
				{this.state.showPopupMenuYN && (
					<ToolbarPopupMenu
						variableNameArray={variableNameArray}
						handleSelectLink={this.handleSelectLink}
						getLang={this.props.getLang}
						closePopupMenu={this.closePopupMenu}
					/>
				)}
			</div>
		);
	}
	
	renderRight() {
		
		var dashboardVariableListJsonObj = this.props.dashboardVariableListJsonObj;
		if (dashboardVariableListJsonObj === null) {
			return;
		}
		
		var innerWidth = this.state.innerWidth;
		
		var displayPopupYN = false;
		if (innerWidth < 1200) {
			displayPopupYN = true;
		}

		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;

		var showExpensesYN = false;
		if (dashboardAppUserType === 99) {
			showExpensesYN = true;
		}
		if (dashboardAppUserType >= 100) {
			showExpensesYN = true;
		}
		if ((dashboardUserType === 2) || (dashboardUserType === 3) || (dashboardUserType === 101) || (dashboardUserType === 102)) {
			showExpensesYN = true;
		}
		
		var i;
		var variableName;
		var itemObj;
		var roomsYN = false;
		var roomPriceYN = false;

		for(i=0; i<dashboardVariableListJsonObj.length; i++) {
			itemObj = dashboardVariableListJsonObj[i];
			variableName = itemObj.variableName;
			if (variableName === "rooms") {
				roomsYN = true;
			}
			if (variableName === "roomprice") {
				roomPriceYN = true;
			}
		}

		var roomRevenueYN = false;
		if (roomsYN && roomPriceYN) {
			roomRevenueYN = true;
		}

		var variableString;
		var jsxCode;
		var jsxArray = [];
		var skipVariableYN;
		var key1;
		var key2;
		var variableNameArray = [];
		
		variableNameArray.push("revenue");
		if (showExpensesYN) {
			variableNameArray.push("expenses");
		}
		
		if (roomRevenueYN) {
			variableNameArray.push("roomrevenue");
		}
		
		for(i=0; i<dashboardVariableListJsonObj.length; i++) {

			itemObj = dashboardVariableListJsonObj[i];
			variableName = itemObj.variableName;
			
			skipVariableYN = false;
			if (variableName === "totalrooms") {
				skipVariableYN = true;
			}

			if (!skipVariableYN) {
				variableNameArray.push(variableName);
			}
		}

		var tab = this.props.tab;
		var selectedYN;
		
		if (displayPopupYN) {

			for(i=0; i<variableNameArray.length; i++) {
				
				variableName = variableNameArray[i];
				variableString = this.props.getLang(DashboardLang, variableName);

				selectedYN = false;
				if (tab === variableName) {
					selectedYN = true;
				}

				if (selectedYN) {
					jsxCode = this.renderPopupLink(variableString, variableNameArray);
					jsxArray.push(jsxCode);
				}				
			}
			
			return jsxArray;
		}

		for(i=0; i<variableNameArray.length; i++) {
			
			if (i>0) {
				key1 = "a-" + i;
				jsxCode = (<div key={key1} className="DashboardMainToolbarText">|</div>);
				jsxArray.push(jsxCode);
			}

			key2 = "b-" + i;

			variableName = 	variableNameArray[i];
			variableString = this.props.getLang(DashboardLang, variableName);

			selectedYN = false;
			if (tab === variableName) {
				selectedYN = true;
			}

			jsxCode = this.renderLink(variableString, variableName, key2, selectedYN);
			jsxArray.push(jsxCode);
		}

		return jsxArray;
	}
	
	render() {
		
		var dashboardName = this.props.dashboardName;
		var dataTip = this.props.getLang(DashboardLang, "selectDashboard");
		
		return (
			<div className="DashboardMainToolbarContainer1">
				<div className="DashboardMainToolbarLeft">
					<div 
						className="DashboardMainToolbarLink"
						onClick={() => this.handleSelectDashboard()}
						data-tip={dataTip}
					>
						{dashboardName}
					</div>
				</div>
				<div className="DashboardMainToolbarRight">
					<div className="DashboardMainToolbarContainer2">
						{this.renderRight()}
					</div>
				</div>
			</div>
		);
	}
}

export default function DashboardMainToolbarFunction(props) {
	const navigate = useNavigate();
	return <DashboardMainToolbar {...props} navigate={navigate} />;
}

